import React from 'react';
import { useHistory } from 'react-router-dom';
import { Icon, Link, TextProps } from '@perch-labs/shrike';
import { Container, Row, RowChild, RowBuffer } from 'styles';
import { ToProp } from 'types/shared';
import { HeadingAndText } from 'components/heading-and-text';

export type Tag = Pick<TextProps, 'tag'>['tag'];

interface IconLinkProps {
  ariaLabel?: string;
  to?: ToProp;
  href?: string;
  onClick?: () => void;
  margin?: Margin;
}

interface Props {
  children?: React.ReactNode;
  hasBottomBorder?: boolean;
  hideTopBorder?: boolean;
  iconLinkProps?: IconLinkProps;
  includesBuffer?: boolean;
  bufferWidth?: string;
  mobileBufferWidth?: string;
  heading?: string | React.ReactNode;
  headingTag?: Tag;
  text?: string;
  warning?: string | null;
  notranslate?: boolean;
}

export const StandardRow = (props: Props) => {
  const history = useHistory();
  const {
    children,
    hasBottomBorder = false,
    hideTopBorder = false,
    iconLinkProps,
    includesBuffer = false,
    bufferWidth = '24px',
    mobileBufferWidth = '24px',
    heading,
    headingTag,
    text,
    warning,
    notranslate,
  } = props;
  const { ariaLabel, href, to, onClick, margin } = iconLinkProps || {};

  const clickRow = () => {
    if (onClick) onClick();
    if (to) history.push(to);
    if (href) window.open(href, '_blank');
  };

  return (
    <Row
      hideTopBorder={hideTopBorder}
      hasBottomBorder={hasBottomBorder}
      onClick={!!onClick || !!to || !!href ? clickRow : undefined} // row becomes link-like when passed a "to" prop, used below to make an Icon Link
    >
      {includesBuffer && (
        <RowBuffer width={bufferWidth} xsmall={{ width: mobileBufferWidth }} />
      )}
      <RowChild>
        {(text || heading || warning) && (
          <HeadingAndText
            heading={heading}
            text={text}
            headingTag={headingTag}
            warning={warning}
            notranslate={notranslate}
          />
        )}
        {children}
        {to && (
          <Container margin={margin || { right: '24px' }}>
            <Link
              aria-label={
                ariaLabel || (typeof heading === 'string' ? heading : '')
              }
              hideIcon={true}
              to={to}
              onClick={onClick}
            >
              <Icon icon="ChevronRight" aria-hidden={true} />
            </Link>
          </Container>
        )}
        {href && (
          <Container margin={margin || { right: '24px' }}>
            <Icon icon="ChevronRight" aria-hidden={true} />
          </Container>
        )}
      </RowChild>
    </Row>
  );
};
